import { endsWith, trimStart } from 'lodash';

export const checkSlash = (url: string): string =>
  `${url}${endsWith(url, '/') ? '' : '/'}`;

export const checkUrlStartSlash = (url: string): string => trimStart(url, '/');
